import { z } from 'zod'

export const CAATypes = z.enum(['MODELING', 'CUSTOMER_USE'])
export type CAATypes = z.infer<typeof CAATypes>

export const CAATypesColors = z.nativeEnum({
  [CAATypes.enum.MODELING]: '#077FDE',
  [CAATypes.enum.CUSTOMER_USE]: '#DF8620'
})
